var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"record_box",attrs:{"href":"https://beian.miit.gov.cn","target":"_blank","rel":"nofollow"}},[_vm._v("粤ICP备2021021979号 -1")])
}
var staticRenderFns = []

export { render, staticRenderFns }